import Vue from 'vue'
import Component from 'vue-class-component'
import { createNewObjectDialog } from './dialogs'

@Component
class NewObjectMixin extends Vue {
  async createNewObject () {
    const res = await createNewObjectDialog(this, this.$restorationObject, this.collectionCode)
    if (res) {
      switch (res['action']) {
        case 'detail':
          this.$router.push({
            name: 'restorations-page-basic-info',
            params: {
              itemId: res['itemId'],
              collectionCode: this.collectionCode
            }
          })
          break
        case 'create_more':
          this.createNewObject()
          break
      }
    }
  }
}

export { NewObjectMixin }
